import { StyledContainer } from "@components/Styled/Container";
import { Video as VideoPlayer } from "@components/Video/Video";
import { clsx } from "clsx";
import React from "react";
import { withVideo, type VideoOutputProps } from "./withVideo";
import Container from "@components/Atomic/Container/Container";
import { NestedWrapper } from "../NestedWrapper";

const VideoWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "aspect-landscape relative")}
  />
);

const InnerVideoWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "inset-0 absolute")} />
);

const Wrapper = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(props.className, props.padding === "yes" && "py-giga")}
  />
);

const Parent = ({ children, width, padding }: Partial<VideoOutputProps>) => {
  return (
    <Wrapper width={width} padding={padding}>
      <VideoWrapper>
        <InnerVideoWrapper data-testid="video-section">
          {children}
        </InnerVideoWrapper>
      </VideoWrapper>
    </Wrapper>
  );
};

const Child = ({ url, autoplay }: Partial<VideoOutputProps>) => {
  return <VideoPlayer video={{ url }} muted={autoplay} playing={autoplay} />;
};

const Video = withVideo(({ styles, url, ...rest }: VideoOutputProps) => {
  return (
    <Container
      styles={styles}
      legacy={!styles?.length}
      background="lightest"
      data-component-type="section-video"
    >
      {url ? (
        <NestedWrapper
          {...rest}
          url={url}
          renderChild={Child}
          renderParent={Parent}
        />
      ) : null}
    </Container>
  );
});

export default Video;
